import { useTranslation } from 'react-i18next';

import { ReactComponent as CalendarSidebar } from 'assets/icons/CalendarSidebar.svg';
import { ReactComponent as Video } from 'assets/icons/Video2.svg';
import { FeatureFlag } from 'utils/Constants';

import SidebarLink from './SidebarLink';

const Sidebar = () => {
  const { t } = useTranslation();

  return (
    <div className="bottom-area-margin border-gray-5 order-last justify-center flex w-full shrink-0 space-x-1 overflow-x-auto border-t p-1 md:order-first md:h-full md:w-[256px] md:flex-col md:justify-start md:space-x-0 md:space-y-2 md:overflow-y-auto md:border-r md:border-t-0 md:p-4">
      <SidebarLink icon={Video} path="/">
        {t('rooms')}
      </SidebarLink>
      <SidebarLink icon={CalendarSidebar} path="/calendar" featureFlag={FeatureFlag.FE_ENABLE_CALENDAR_VIEW_PERM}>
        {t('calendar')}
      </SidebarLink>
    </div>
  );
};

export default Sidebar;
